import { useState, useEffect, useEffectEvent } from 'react'

export const useIsTabletSize = () => {
  const [isTablet, setIsTablet] = useState(false)

  const checkScreen = useEffectEvent(() => {
    const width = window.innerWidth

    setIsTablet(width >= 769 && width <= 1200)
  })

  useEffect(() => {
    checkScreen()
    window.addEventListener('resize', checkScreen)
    return () => window.removeEventListener('resize', checkScreen)
  }, [])

  return { isTablet }
}
